var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMapPin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 1.375C8.995 1.37727 7.07277 2.17477 5.65502 3.59252C4.23727 5.01027 3.43977 6.9325 3.4375 8.9375C3.4375 15.4086 10.3125 20.2984 10.6047 20.5047C10.7218 20.5827 10.8593 20.6243 11 20.6243C11.1407 20.6243 11.2782 20.5827 11.3953 20.5047C11.6875 20.2984 18.5625 15.4086 18.5625 8.9375C18.5602 6.9325 17.7627 5.01027 16.345 3.59252C14.9272 2.17477 13.005 1.37727 11 1.375V1.375ZM11 6.1875C11.5439 6.1875 12.0756 6.34878 12.5278 6.65096C12.9801 6.95313 13.3325 7.38262 13.5407 7.88512C13.7488 8.38762 13.8033 8.94055 13.6972 9.474C13.5911 10.0074 13.3291 10.4974 12.9445 10.882C12.5599 11.2666 12.0699 11.5286 11.5365 11.6347C11.0031 11.7408 10.4501 11.6863 9.94762 11.4782C9.44512 11.27 9.01563 10.9176 8.71346 10.4653C8.41128 10.0131 8.25 9.4814 8.25 8.9375C8.25 8.20815 8.53973 7.50868 9.05546 6.99296C9.57118 6.47723 10.2707 6.1875 11 6.1875V6.1875Z",
    fill: "#8047F8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPin);
export default __webpack_public_path__ + "static/media/map-pin.7c3a811405824ad51f6755c91dbd707f.svg";
export { ForwardRef as ReactComponent };